const isShadow = process.env.NODE_ENV === "shadow";

const state = {
  workItems: {}
};

const getters = {
  workItems: state => state.workItems
};

const mutations = {
  GET_WORK_ITEMS(state, doc) {
    state.workItems = doc
      .map(item => {
        item.image = item.projectImage;
        return item;
      })
      .filter(item => {
        return isShadow ? true : !item.shadowPublish;
      });
  }
};

export default {
  state,
  getters,
  mutations
};
